import React from 'react';

import {FormikErrors, withFormik} from 'formik';

import PropTypes from 'prop-types';
import {FieldShape} from 'commons/shapes';
import {PersonTypes} from 'commons/constants';
import PersonalInfoInnerForm from './PersonalInfoInnerForm';
import {ConsigneeData, InferPropTypes} from 'commons/types/Types';
import {formValidator, setDefaultValue} from 'commons/utils/Functions';

PersonalInfoForm.propTypes = {
    fatherKycId: PropTypes.number.isRequired,
    expedientId: PropTypes.number.isRequired,
    auxConsignee: PropTypes.any,
    flow: PropTypes.any,
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
};

const FormControl = withFormik<InferPropTypes<typeof PersonalInfoForm.propTypes>, ConsigneeData>({
    mapPropsToErrors: () => {
        return {
            expedientId: '',
            workflowId: '',
            viewId: '',
            viewFatherId: '',
            kycId: '',
            fullName: '',
            businessDescription: '',
            email: '',
            personKey: '',
        };
    },
    mapPropsToValues: (props) => {
        const {auxConsignee, expedientId, flow, fatherKycId} = props;
        if (auxConsignee) {
            return {
                expedientId: setDefaultValue(auxConsignee.expedientId, 0),
                workflowId: setDefaultValue(auxConsignee.workflowId, 0),
                viewId: setDefaultValue(flow.data.viewId, 0),
                viewFatherId: setDefaultValue(flow.data.fatherId, 0),
                kycId: setDefaultValue(auxConsignee.kycId, 0),
                fullName: setDefaultValue(auxConsignee.fullName, ''),
                businessDescription: setDefaultValue(auxConsignee.businessDescription, ''),
                email: setDefaultValue(auxConsignee.email, ''),
                personKey: setDefaultValue(auxConsignee.personKey, 0),
                fatherKycId: setDefaultValue(auxConsignee.fatherKycId, 0),
            };
        } else {
            return {
                expedientId: expedientId,
                workflowId: 0,
                viewId: flow.data.viewId,
                viewFatherId: flow.data.fatherId,
                kycId: 0,
                fullName: '',
                businessDescription: '',
                email: '',
                personKey: PersonTypes.MORAL,
                fatherKycId: fatherKycId,
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: ConsigneeData, props) => {
        const errors: FormikErrors<ConsigneeData> = {};
        formValidator(props.fields, errors, values);
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(PersonalInfoInnerForm);
function PersonalInfoForm(props: InferPropTypes<typeof PersonalInfoForm.propTypes>) {
    const {fields, submitHandler, auxConsignee, expedientId, flow, fatherKycId} = props;
    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            fields={fields}
            submitHandler={submitHandler}
            auxConsignee={auxConsignee}
            expedientId={expedientId}
            flow={flow}
            fatherKycId={fatherKycId}
        />
    );
}

export default PersonalInfoForm;
